import { PROCESS, WHATSAPP_LINK } from '../lib/site';

const ProcessSection = () => {
  return (
    <section id="proceso" className="py-24 md:py-32 max-w-[1400px] mx-auto px-6">
      <div className="reveal max-w-2xl">
        <p className="label">Cómo trabajamos</p>
        <h2 className="font-display font-black uppercase tracking-[-0.02em] text-section-title mt-5">
          Un proceso claro, <em className="font-serifit normal-case font-normal text-clay">sin letra pequeña</em>
        </h2>
        <p className="mt-6 text-ink-soft leading-relaxed">
          Sabemos que una obra genera dudas. Por eso cada fase está documentada,
          con plazos y responsables. Tú decides los acabados; nosotros nos encargamos del resto.
        </p>
      </div>

      <ol className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-line border border-line">
        {PROCESS.map((step, i) => (
          <li key={step.step} className="reveal bg-paper p-8 md:p-9 group" style={{ transitionDelay: `${i * 60}ms` }}>
            <span className="stat-number text-5xl text-paper-3 group-hover:text-clay transition-colors duration-300 select-none">
              {step.step}
            </span>
            <h3 className="mt-5 font-display font-bold text-xl tracking-tight uppercase">{step.title}</h3>
            <p className="mt-3 text-sm text-ink-soft leading-relaxed">{step.text}</p>
          </li>
        ))}
      </ol>

      <div className="reveal mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-5 justify-between bg-paper-2 border border-line rounded-[4px] px-7 py-6">
        <p className="font-semibold text-lg tracking-tight">
          ¿Empezamos? La primera visita es gratis y sin compromiso.
        </p>
        <a
          href={WHATSAPP_LINK('Hola, me gustaría reservar una visita para un presupuesto.')}
          target="_blank"
          rel="noopener noreferrer"
          className="btn bg-ink text-paper shrink-0"
        >
          Reservar visita
        </a>
      </div>
    </section>
  );
};

export default ProcessSection;
